module.exports = __webpack_public_path__ + "img/green-coral-07.218727b2.png";